var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 32,
      height: 32,
      viewBox: "0 0 32 32",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9995 21.3333H9.6128C6.8048 21.3333 4.27147 19.2867 4.02214 16.488C3.73814 13.328 6.23014 10.6667 9.3328 10.6667H11.9995C12.7355 10.6667 13.3328 10.0707 13.3328 9.33333C13.3328 8.596 12.7355 8 11.9995 8H9.61147C5.54614 8 1.91814 10.916 1.4008 14.948C0.775469 19.8253 4.57547 24 9.3328 24H11.9995C12.7355 24 13.3328 23.404 13.3328 22.6667C13.3328 21.9293 12.7355 21.3333 11.9995 21.3333ZM10.6661 16C10.6661 16.7373 11.2635 17.3333 11.9995 17.3333H19.9995C20.7355 17.3333 21.3328 16.7373 21.3328 16C21.3328 15.2627 20.7355 14.6667 19.9995 14.6667H11.9995C11.2635 14.6667 10.6661 15.2627 10.6661 16ZM22.3449 8.00027C26.4343 8.00027 30.1036 10.9296 30.6036 14.9896C31.2023 19.8509 27.4103 24.0003 22.6663 24.0003H19.9996C19.2636 24.0003 18.6663 23.4043 18.6663 22.6669C18.6663 21.9296 19.2636 21.3336 19.9996 21.3336H22.6663C25.7689 21.3336 28.2609 18.6723 27.9769 15.5123C27.7276 12.7136 25.1943 10.6669 22.3849 10.6669H19.9996C19.2636 10.6669 18.6663 10.0709 18.6663 9.3336C18.6663 8.59627 19.2569 8.00027 20.3316 8.00027H22.3449Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgLink, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/link.0bcbf1e0.svg";
export { ForwardRef as ReactComponent };